import { Input, OnInit, Component, EventEmitter, Output } from '@angular/core';
import {
    ExternalAssessmentStates,
    AssessmentType
} from '../../constants-types/Enums';
import { AssessmentMethods } from '../../core-data-model/AssessmentMethods';
import { Job } from '../../core-data-model/Job.model';
import { Person } from '../../core-data-model/Person.model';
import { SearchResult } from '../../core-data-model/SearchResult.model';
import { DateFormatUtility } from '../../core-utilities/DateFormat.utility';
import { TranslationService } from '../../translations';
import { AssessmentStatusTableCellProperties } from './AssessmentStatusTableCellProperties';

@Component({
    selector: 'cognitive-thumb',
    template: `
        @if (properties) {
            @if (properties.thumbnailConfig) {
                <div>
                    <assessment-thumbnail
                        [properties]="properties.thumbnailConfig"
                    ></assessment-thumbnail>
                </div>
            } @else {
                @if (properties.reminderConfig) {
                    <assessment-reminder-v2
                        (dataChange)="dataChange.emit()"
                        [properties]="properties.reminderConfig"
                    ></assessment-reminder-v2>
                }
            }
        }
    `,
    standalone: false
})
export class NewTableCognitiveThumbnail implements OnInit {
    @Input()
    result: SearchResult;
    @Input()
    displayPendingCog = false; // Determines whether or not the thumbnail displays the highest scored completed cog or most recently sent pending cog
    @Output()
    dataChange = new EventEmitter();

    properties: AssessmentStatusTableCellProperties;

    constructor(
        private TR: TranslationService,
        private date: DateFormatUtility
    ) {}

    ngOnInit() {
        this.properties = this.getCognitiveAssessmentStatus(this.result);
    }

    private getCognitiveAssessmentStatus(
        result: SearchResult
    ): AssessmentStatusTableCellProperties {
        const id: string = result.id;

        const cognitiveAssessmentStatus =
            {} as AssessmentStatusTableCellProperties;

        if (result instanceof Person) {
            const firstName = result.firstName;
            const lastName = result.lastName;

            const displayedCognitiveAssessment =
                result.getCognitiveAssessmentForThumbnailDisplay(
                    this.displayPendingCog
                );

            // Case: Scored Cognitive Assessment => Display the Cognitive Chart
            if (
                displayedCognitiveAssessment &&
                displayedCognitiveAssessment.id &&
                displayedCognitiveAssessment.assessmentState ===
                    ExternalAssessmentStates.Completed
            ) {
                const displayDT = this.date.transformDate(
                    displayedCognitiveAssessment.completedDate
                );
                cognitiveAssessmentStatus.thumbnailConfig = {
                    firstName,
                    lastName,
                    personOrJob: {
                        isPerson: true,
                        id
                    },
                    svgType: 'cognitive',
                    personCognitiveScore: displayedCognitiveAssessment.score,
                    tooltip: `${this.TR.key('DateCompleted')} : ${displayDT}`,
                    cognitiveCompletedDate:
                        displayedCognitiveAssessment.completedDate
                };
                // Case: Assessment Send and is not complete => Remind
                // Case: No Cognitive Assessment Sent => Send
            } else {
                cognitiveAssessmentStatus.reminderConfig =
                    AssessmentMethods.getReminderConfig(
                        displayedCognitiveAssessment,
                        AssessmentType.Cognitive,
                        result.id,
                        displayedCognitiveAssessment
                            ? displayedCognitiveAssessment.sentDate
                            : null,
                        this.TR,
                        this.date
                    );
            }
        } else if (result instanceof Job && result.cognitiveTarget) {
            cognitiveAssessmentStatus.thumbnailConfig = {
                personOrJob: {
                    isPerson: false,
                    id
                },
                svgType: 'cognitive',
                jobCognitiveScore: result.cognitiveTarget
            };
        }
        return cognitiveAssessmentStatus;
    }
}
